import axios, { Canceler } from 'axios';
import Constants from '../Constants';
import http from './HttpService';

const AWSS3 = axios.create({ headers: { 'Content-Type': 'multipart/form-data' } });
const { CancelToken } = axios;

const uploadInProgress: { [key: string]: Canceler } = {};

interface S3Credential {
    key: string;
    policy: string;
    region: string;
    signature: string;
    bucket: string;
    acl: string;
}

const getCredentials = async (): Promise<S3Credential> => {
    const response = await http.get(Constants.S3_SECURITY_URI, { params: { uploadBucket: true } });
    return response.data;
};

const uploadFile = async (file: File, key: string, onUploadProgress: (progress: number) => void) => {
    const credential = await getCredentials();
    const url: string = `https://${credential.region}.amazonaws.com/${credential.bucket}/`;
    const form: FormData = new FormData();
    let returnUrl = null;
    form.append('key', key);
    form.append('AWSAccessKeyId', credential.key);
    form.append('acl', credential.acl);
    form.append('policy', credential.policy);
    form.append('signature', credential.signature);
    form.append('Content-Type', file.type);
    form.append('file', file);
    await AWSS3.post(url, form, {
        cancelToken: new CancelToken((c) => {
            uploadInProgress[key] = c;
        }),
        onUploadProgress: (progressEvent) => {
            onUploadProgress(Math.round((progressEvent.loaded / progressEvent.total) * 100));
        },
    })
        .then(() => {
            returnUrl = url + encodeURIComponent(key);
        })
        .catch(() => {});
    return returnUrl;
};

const uploadHtml = async (html: string, key: string) => {
    const credential = await getCredentials();
    const url: string = `https://${credential.region}.amazonaws.com/${credential.bucket}/`;
    const form: FormData = new FormData();
    form.append('key', key);
    form.append('AWSAccessKeyId', credential.key);
    form.append('acl', credential.acl);
    form.append('policy', credential.policy);
    form.append('signature', credential.signature);
    form.append('Content-Type', 'text/html');
    form.append('file', new Blob([html], { type: 'text/html;charset=UTF-8' }));
    await AWSS3.post(url, form, {
        cancelToken: new CancelToken((c) => {
            uploadInProgress[key] = c;
        }),
        // onUploadProgress: (progressEvent) => {
        //     onUploadProgress(Math.round((progressEvent.loaded / progressEvent.total) * 100));
        // },
    });
    return url + encodeURIComponent(key);
};

const cancelUpload = (key: string) => {
    if (!!uploadInProgress[key]) {
        uploadInProgress[key]();
        delete uploadInProgress[key];
    }
};

export { uploadFile, cancelUpload, uploadHtml };
